<template>
  <div style="height: 100%" v-show="showRegister">
    <div class="register special">
      <!-- only display log and download button in pc version -->
      <div v-if="!isMobile" class="top_info">
        <a :href="logoLink">
          <img
            href=""
            :src="
              siteType.GetSiteType() == siteType.SITE_TYPE_NUTS
                ? '/static/img/register/logo.svg'
                : '/static/img/register/KKBrand_Logo.png'
            "
          />
        </a>
        <div @click="to_download" class="download_btn" />
        <div @click="to_download" class="download_text">
          {{ $t("register.LAB_DOWNLOAD") }}
        </div>
      </div>
      <div
        v-if="bannerArray[0] === undefined"
        class="top"
        :style="{ backgroundImage: backgroundBanner }"
      >
        <div class="logo"></div>
      </div>
      <van-swipe
        v-else
        class="my-swipe"
        :show-indicators="false"
        :autoplay="3000"
        :key="refreshVan"
      >
        <van-swipe-item v-for="(item, index) in bannerArray" :key="index">
          <img
            class="van_banner_image"
            :src="item.photo"
            @click="openNewWindow(item.url)"
            style="cursor: pointer"
          />
        </van-swipe-item>
      </van-swipe>
      <registerForm
        :country="country"
        :platform="platform"
        :isOlakk="isOlakk"
        @setBackgroundImage="setBackgroundImage"
        @setIsInviteCode="is_invitecode = $event"
      ></registerForm>

      <div class="empty_bottom"></div>
    </div>
    <!-- olakk show mission info -->
    <!-- <div class="misssion-block" v-if="isOlakk">
        <a target="_blank" href="https://kkpoker.news/bdcbblog">
          <img ref="missionTitle" class="logo">
        </a>
      </div> -->
    <template v-if="isMobile">
      <template v-if="siteType.GetSiteType() != siteType.SITE_TYPE_NUTS">
        <div class="swiper-container">
          <single-swiper
            key="mobile"
            :isPagination="true"
            :imageList="uspImages"
            :swiperWidth="'100%'"
            :imageWidth="'100%'"
            :swiperOptions="{
              slidesPerView: 1.26,
              spaceBetween: 0,
              loop: true,
              pagination: {
                el: '.swiper-pagination',
                clickable: true,
                type: 'bullets',
                dynamicBullets: false,
              },
            }"
          />
        </div>
        <div class="empty_bottom"></div>
        <!-- olakk hide more-player & club -->
        <template v-if="!isOlakk">
          <div class="float_top">
            <img src="/static/img/register/KKBrand_Logo.png" />
            <div @click="to_download" class="download_btn" />
            <div @click="to_download" class="download_text">
              {{ $t("register.LAB_DOWNLOAD") }}
            </div>
          </div>
          <div class="more-player">
            <p>{{ $t("register.LAB_BE_MORE") }}</p>
          </div>
          <div class="club">
            <h2 class="title">
              <img class="icon_02" src="/static/img/home/icon_02.png" alt />
              {{ $t("register.LAB_PLAY_BEST") }}
            </h2>
            <div class="divide-line"></div>
            <div class="poker-con">
              <div class="poker-item">
                <div class="div_picture">
                  <div class="primary_color poker-item-title1">
                    {{ $t("register.LAB_ENJOY") }}
                  </div>
                  <img class="picture" src="/static/img/home/p1.jpg" alt />
                </div>

                <div class="poker-item-con">
                  <p class="sub_title">{{ $t("register.LAB_MORE") }}</p>
                  <p>{{ $t("register.LAB_PLAY_GAME") }}</p>
                  <p>{{ $t("register.LAB_MODE") }}</p>
                  <p>{{ $t("register.LAB_TODAY") }}</p>
                </div>
              </div>
              <div class="divide-line"></div>
              <div class="poker-item">
                <div class="div_picture">
                  <div
                    class="primary_color poker-item-title2"
                    v-text="$t('register.LAB_ACTION')"
                  ></div>
                  <img class="picture" src="/static/img/home/p2.jpg" alt />
                </div>

                <div class="poker-item-con">
                  <p class="sub_title">{{ $t("register.LAB_MASTER") }}</p>
                  <p>{{ $t("register.LAB_SAME_TIME") }}</p>
                  <p>{{ $t("register.LAB_SWIPE") }}</p>
                </div>
              </div>
              <div class="divide-line"></div>
              <div class="poker-item">
                <div class="div_picture">
                  <div class="primary_color poker-item-title3">
                    {{ $t("register.LAB_SAFE") }}
                  </div>
                  <img class="picture" src="/static/img/home/p3.jpg" alt />
                </div>

                <div class="poker-item-con">
                  <p class="sub_title">{{ $t("register.LAB_ASSEM") }}</p>
                  <p>{{ $t("register.LAB_RULES") }}</p>
                  <p>{{ $t("register.LAB_TABLES") }}</p>
                  <p>{{ $t("register.LAB_EVERY_DAY") }}</p>
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
      <div class="float_top" v-else>
        <img src="/static/img/register/logo.svg" />
        <div @click="to_download" class="download_btn" />
        <div @click="to_download" class="download_text">
          {{ $t("register.LAB_DOWNLOAD") }}
        </div>
      </div>
    </template>
    <template v-else>
      <pc-register />
    </template>
    <div class="footer-container" :class="{ denmark: isDenmark }">
      <root-footer-nuts
        v-if="siteType.GetSiteType() == siteType.SITE_TYPE_NUTS"
      />
      <root-footer-denmark v-else-if="isDenmark"></root-footer-denmark>
      <root-footer v-else />
    </div>
    <transition name="van-slide-up" v-if="isMobile && isOlakk">
      <div
        v-show="showFloat"
        class="float_bottom"
        :style="{ backgroundImage: backgroundFooterImage }"
      >
        <div @click="to_download" class="download_btn" />
        <div @click="showFloat = false" class="close" />
      </div>
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
import { getBackgroundImage } from "@/utils/backgroundImage";
import { switchLanguage, langCode } from "@/utils/switchLang.js";
import SingleSwiper from "@/components/SwiperComponent/SingleSwiper.vue";
import RootFooter from "@/components/layout/RootFooter.vue";
import RootFooterNuts from "@/components/layout/RootFooterNuts.vue";
import RootFooterDenmark from "@/components/layout/RootFooterDenmark.vue";
import registerForm from "@/components/registerForm.vue";
import PcRegister from "@/views/pcRegister";
import { olaKKClubs, setClubBannerImage } from "../configs/clubs";
import { setLicenseType } from "../configs/licenseType";
import { getFingerprint, toBury } from "../configs/userStatsTrack";
import { getUspData } from "../configs/register";
import request from "@/utils/request";
import store from "../store";
import { getGps } from "@/utils/browserCheck.js";
import siteType from "../configs/siteType";
import { logoLinkMixin } from "../mixin/logoLink";

const toJudgeIp = function (next) {
  const $XHR = new XMLHttpRequest();
  $XHR.onreadystatechange = function () {
    if ($XHR.readyState === 4) {
      // 请求成功
      if ($XHR.status === 200) {
        // 响应成功
        const $RESPONSE = JSON.parse($XHR.response);
        // setLicenseType($RESPONSE)
        store.commit("SET_PLATFORM", $RESPONSE.platform);
        next((vm) => {
          vm.setData($RESPONSE.platform);
          if (vm.not_invitecode) {
            const buryType =
              vm.$route.params.invitecode === undefined
                ? "LinkAccess"
                : "InviteLinkAccess";
            const f3 = vm.$route.params.invitecode === undefined ? 1 : 2;
            const platform = $RESPONSE.platform;
            toBury(vm, buryType, 801, 1, f3, 0, 0, platform);
          }
        });
      }
    }
  };

  // setTimeout(function () {
  //   next((vm) => {
  //     vm.setData('timeout')
  //     const buryType =
  //       vm.$route.params.invitecode === undefined
  //         ? 'LinkAccess'
  //         : 'InviteLinkAccess'
  //     const f3 = vm.$route.params.invitecode === undefined ? 1 : 2
  //     toBury(vm, buryType, 801, 1, f3, 0, 0, 'timeout')
  //   })
  // }, 2000)

  // 判斷是否為手機及獲取經緯度
  getGps().then((res) => {
    const { lat, lon } = res;
    const baseUrl = request.defaults.baseURL + "/poker-api/checkIpLegal?type=1";
    const url =
      lat && lon ? `${baseUrl}&gps_lat=${lat}&gps_lon=${lon}` : baseUrl;
    $XHR.open("get", url, true);
    $XHR.send(null);
  });
};
export default {
  name: "register",
  mixins: [logoLinkMixin],
  data() {
    return {
      show: false,
      refreshVan: 0,
      platform: "",
      captchaKey: "",
      showFloat: false,
      showRegister: false,
      backgroundBanner: "",
      backgroundSection: "",
      backgroundFooterImage: "",
      country: "",
      not_invitecode: false,
      register_load: false,
      bannerArray: [],
      is_invitecode: false,
      siteType,
    };
  },
  methods: {
    openNewWindow(url) {
      if (!url) {
        return;
      }
      window.open(url);
    },
    setLang() {
      const BrowLang = switchLanguage();
      this.country = this.$route.query.lang || BrowLang;
    },
    setData(platform) {
      if (platform) {
        this.platform = platform;
      }
    },
    initClubInfoByInvitaionCode() {
      if (this.$route.params.invitecode === undefined) {
        // this.show_club = false
        this.showRegister = true;
        this.not_invitecode = true;
        const images = getBackgroundImage({}, this.country);
        this.setBackgroundImage(images);
      }
    },
    setBackgroundImage(res) {
      this.backgroundBanner = res.backgroundBanner;
      this.backgroundSection = res.backgroundSection;
      this.backgroundFooterImage = res.backgroundFooterImage;
      this.showRegister = true;
    },
    setOlakkBanner(invitecode) {
      if (!olaKKClubs.includes(invitecode)) {
        return;
      }
      const path = "/static/img/mission/";
      const obj = setClubBannerImage(invitecode);
      this.bannerArray.push({ photo: path + obj.moibleHeader });
      // this.$refs.missionTitle.src = obj.mobileTitle
    },
    to_download() {
      this.$gtag.event("Click", {
        event_category: "SignUp Mobile",
        event_label: "Download",
      });
      const clubInfo = this.$store.state.club_info;
      const buryType = !clubInfo[0]
        ? "RegisteredandDownload"
        : "InviteRegisteredandDownload";
      const f3 = !clubInfo[0] ? 1 : 2;
      toBury(this, buryType, 801, 3, f3, 0, 0, this.platform, clubInfo[3]);
      if (siteType.GetSiteType() == siteType.SITE_TYPE_NUTS) {
        location.href = "https://nutspoker.cc/downloadpage";
      } else {
        // kk 的 下载判断
        if (this.isWorldDownloadCountry) {
          location.href = "https://kkpoker.world/downloadpage/";
        } else {
          if (this.$root.currentType === "mannin") {
            if (langCode.includes(this.country)) {
              location.href = `https://${this.country}.kkpoker.net/downloadpage`;
            } else if (this.country === "pt") {
              location.href = "https://br.kkpoker.net/downloadpage";
            } else if (this.country === "mn") {
              location.href = "https://kkmon.net/downloadpage/";
            } else {
              location.href = "https://kkpoker.net/downloadpage";
            }
          } else {
            location.href = "https://kkpoker.co/";
          }
        }
      }
    },
    toScroll() {
      document
        .querySelector("#default-layout")
        .scrollIntoView({ block: "start", behavior: "smooth" });
    },
    // 动态加载Facebook Pixel
    loadFacebookPixel(pixelId) {
      if (!pixelId) return;

      /**
       * 因为 index.html中的 google tag manager 脚本会加载 fbq 脚本
       * 所以这里不需要再动态创建脚本标签加载 fbq 脚本
       * 但是需要更改 fbq 的初始化代码，替换pixelId
       */
      // 初始化Facebook Pixel
      // !function(f,b,e,v,n,t,s) {
      //   console.log('loadFacebookPixel ----------------------------------------');

      //     if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      //     n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      //     if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      //     n.queue=[];t=b.createElement(e);t.async=!0;
      //     t.src=v;s=b.getElementsByTagName(e)[0];
      //     s.parentNode.insertBefore(t,s)
      // }(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');

      fbq("init", pixelId);
      fbq("track", "PageView");

      console.log("Facebook Pixel loaded with ID:", pixelId);
    },
  },
  beforeRouteEnter(to, from, next) {
    toJudgeIp(next);
  },
  created() {
    this.setLang();
    this.initClubInfoByInvitaionCode();
  },
  mounted() {
    getFingerprint(this);
    this.$root.currentType = window.currentType;
    const invitecode = this.$route.params.invitecode
      ? this.$route.params.invitecode.toLocaleLowerCase()
      : null;
    // decide olakk page banner in different club id
    this.setOlakkBanner(invitecode);
    setTimeout(() => {
      this.showFloat = true;
      this.refreshVan++;
    }, 500);

    // 根据 invitecode 注入不同的 pixel id
    let pixelIdMap = {
      123: "1326897159233539",
    };
    const pixelId = pixelIdMap[invitecode];
    this.loadFacebookPixel(pixelId);

    // 新功能：此页面支持通过参数打开app
    const urlParams = new URLSearchParams(window.location.search);
    const { open_app, game_type, roomid } = Object.fromEntries(
      urlParams.entries()
    );
    if (open_app === "1") {
      // 更改网站的meta分享信息
      document.title = "准备好成为下一个冠军了吗？";
      document
        .querySelector('meta[name="description"]')
        .setAttribute("content", `${game_type}正在开打，马上来报名`);

      const openApp = (schemeUrl, fallbackUrl) => {
        try {
          window.location.href = schemeUrl;
        } catch (error) {
          console.error("Error opening app:", error);
        }
      };

      const isIOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      const isAndroid = /Android/.test(navigator.userAgent);
      const isPc = !isIOS && !isAndroid;

      const linkConfig = {
        kk: {
          iom_andriod: `kkpoker://platformapi?scene=hall&game_type=${game_type}&roomid=${roomid}`,
          iom_ios: `KKPokerGame://platformapi?scene=hall&game_type=${game_type}&roomid=${roomid}`,
          co_andriod: `kkpokerglobal://platformapi?scene=hall&game_type=${game_type}&roomid=${roomid}`,
          co_ios: `KKPokerGlobal://platformapi?scene=hall&game_type=${game_type}&roomid=${roomid}`,
        },
        nuts: {
          andriod: `nutspoker://platformapi?scene=hall&game_type=${game_type}&roomid=${roomid}`,
          ios: `nutspoker://platformapi?scene=hall&game_type=${game_type}&roomid=${roomid}`,
        },
      };
      
      if (isPc) {
        // PC端暂不支持打开PC版程序，所以停留在页面中提示用户下载
        return;
      } else {
        const getSchemeUrl = () => {
          if (siteType.GetSiteType() == siteType.SITE_TYPE_NUTS) {
            if (isIOS) {
              return linkConfig.nuts.ios;
            } else if (isAndroid) {
              return linkConfig.nuts.andriod;
            }
          } else {
            if (window.currentType === "curacao") {
              if (isIOS) {
                return linkConfig.kk.co_ios;
              } else if (isAndroid) {
                return linkConfig.kk.co_andriod;
              }
            } else {
              if (isIOS) {
                return linkConfig.kk.iom_ios;
              } else if (isAndroid) {
                return linkConfig.kk.iom_andriod;
              }
            }
          }
        };
        let schemeUrl = getSchemeUrl();
        openApp(schemeUrl);
      }
    }
  },
  components: {
    PcRegister,
    SingleSwiper,
    RootFooter,
    RootFooterDenmark,
    RootFooterNuts,
    registerForm,
  },
  computed: {
    isOlakk() {
      const invitecode = this.$route.params.invitecode
        ? this.$route.params.invitecode.toLocaleLowerCase()
        : null;
      const isOlakk = olaKKClubs.includes(invitecode);
      return isOlakk;
    },
    isMobile() {
      const isDesktop = window.innerWidth > 768;
      return !isDesktop;
    },
    uspImages() {
      return getUspData(this.$i18n.locale, this.globalConfig, true);
    },
    isDenmark() {
      return window.currentType === "denmark";
    },
  },
};
</script>

<style lang="less" scoped>
// path: src/assets/scss/variables.scss
@import "@/assets/scss/variables.scss";

.footer-container {
  display: flex;
  justify-content: center;
}

.desktop {
  .register.special {
    display: flex;
    align-items: center;

    .top {
      margin-top: 0px;
      margin-bottom: 50px;
      height: 23%;
    }

    .empty_bottom {
      height: 50px;
    }
  }
}

.van_banner_image {
  width: 100%;
}

.misssion-block {
  margin-bottom: 50px;
  text-align: center;
  // background-color: white;
  background-color: #151515;

  .logo {
    margin: 0;
    width: 100%;
  }

  .mission {
    max-width: 1000px;
    padding: 0 30px;

    .title {
      margin-top: 10px;
      text-align: center;
      font-size: 28px;
      font-weight: bold;
      text-decoration: underline;
      text-underline-offset: 5px;
    }

    .description {
      margin-top: 10px;
      text-align: center;
      font-size: 18px;
      text-transform: uppercase;
    }
  }

  img {
    margin: 10px 0;
    width: 100%;
  }
}

.float_top {
  z-index: 100;
  width: 100%;
  max-width: 750px;
  top: 0px;
  height: 72px;
  position: fixed;
  background-color: #000000;
  opacity: 0.75;

  img {
    position: absolute;
    left: 50px;
    top: 15px;
    width: 170px;
    height: auto;
  }

  .download_btn {
    position: absolute;
    left: 530px;
    top: 15px;
    width: 40px;
    height: 40px;
    background-size: 100% auto;
    background-image: url("/static/img/register/icon_download.png");
    background-repeat: no-repeat;
    background-position: center top;
    cursor: pointer;
  }

  .download_text {
    color: #ffffff;
    position: absolute;
    left: 580px;
    top: 25px;
    font-size: 20px;
  }
}

.more-player {
  position: relative;
  widows: 100%;
  background-color: #1f9d56;

  p {
    display: block;
    font-size: 57px;
    line-height: 84px;
    width: 90%;
    padding: 42px;
    color: #ffffff;
    font-weight: 900;
    margin: 0 auto;
    word-break: break-word;
  }
}

.club {
  background-color: #ffffff;
  padding: 64px 0px 30px 0px;
  color: #333333;

  .title {
    padding: 0px 24px;
    font-size: 30px;
    margin: 0px 0px 20px 0px;
    font-weight: bold;

    .icon_02 {
      width: 26px;
      vertical-align: middle;
      margin-bottom: 6px;
    }
  }

  .divide-line {
    width: 100%;
    height: 1px;
    background-color: #c0c0c0;
  }

  .poker-con {
    padding: 0px 24px;

    .poker-item {
      position: relative;
      margin: 40px 0px 60px 0px;

      .div_picture {
        position: relative;
        width: 100%;

        .poker-item-title1,
        .poker-item-title2,
        .poker-item-title3 {
          position: absolute;
          width: 250px;
          bottom: 300px;
          font-weight: bold;
          font-size: 28px;
          white-space: pre-line;
        }

        .poker-item-title2 {
          right: 0px;
        }

        .picture {
          display: block;
          width: 100%;
        }
      }

      .poker-item-con {
        .sub_title {
          font-size: 26px;
          margin-top: 20px;
          font-weight: 500;
          margin-bottom: 16px;
        }

        p {
          font-size: 20px;
          line-height: 28px;
          margin-bottom: 10px;
          font-weight: 100;
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
.swiper-container {
  margin-bottom: 1.733333rem;
  width: 100%;
  background-image: url("/static/img/home/bg_2.png");
  background-position: 100% 113%;
  background-repeat: no-repeat;
  background-size: 100% auto;
}
</style>
<style lang="less">
body,
#default-layout {
  background-color: #151515;
}

html,
body,
#default-layout {
  height: 100%;
}

.register_toast {
  background-color: #000000;
  padding: 14px 10px;

  .van-toast__text {
    font-size: 24px;
    line-height: 30px;
    max-width: 550px;
  }
}
</style>
<style lang="less" scoped>
.my-swipe {
  min-height: 350px !important;
}

.popup-tips {
  background-color: rgba(0, 0, 0, 0.8);
  width: 80%;
  height: 100%;

  // margin-top: 110px;
  .close_btn {
    display: block;
    width: 24px;
    margin: 30px 50px;
    z-index: 2;
  }

  .slider-item {
    padding: 30px 50px;
    color: #dadada;
    font-size: 32px;

    // border-top: 2px solid #3c3c3c;
    // border-top: 2px solid #fff;
    a {
      color: #dadada;
    }

    .contact {
      display: flex;
      align-items: center;

      img {
        width: 39px;
        margin-right: 10px;
        vertical-align: middle;
        display: inline-block;
      }
    }
  }
}

.register {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 1100px;
  background-color: #151515;
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  .logo {
    display: block;
    margin: 0px auto;
    width: 420px;
    height: 280px;
    margin-top: -20px;
    margin-bottom: -10px;
  }

  .to_download {
    text-align: center;
    margin-bottom: 40px;
    font-size: 28px;
    color: #ffffff;

    a {
      font-size: 28px;
      color: #4a965b;
    }
  }

  .empty_bottom {
    width: 100%;
    height: 90px;
  }
}

.register.special {
  justify-content: space-between;

  // min-height: 1340px;
  .top {
    height: 250px;
    position: relative;
    width: 100%;
    height: 23%;
    margin-top: 48px;
    margin-bottom: 0px;
    min-height: 300px;
    max-height: 400px;
    background-size: 100% auto;
    background-position: center center;
    background-repeat: no-repeat;
  }

  .logo {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .title {
    margin-top: 20px;
  }

  // .content {
  //   background-image: url('/static/img/register/formback.jpg');
  //   background-size: 100% auto;
  //   background-position: center -124px;
  //   background-repeat: no-repeat;
  // }
}

.lading {
  position: relative;
  width: 100%;
  height: 1164px;
  //background-image: url(/mobile/static/img/register/section2.jpg);
  background-size: 100% auto;
  background-position: center top;
  background-repeat: no-repeat;

  .play_buttom {
    position: absolute;
    width: 360px;
    height: 90px;
    top: 1010px;
    left: 195px;
    background-image: url("/static/img/register/btn_common_1_n.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    cursor: pointer;

    p {
      font-size: 28px;
      line-height: 90px;
      text-align: center;
      color: #ffffff;
    }
  }
}

.lading_nuts {
  position: relative;
  width: 100%;
  height: 1164px;
  //background-image: url(/mobile/static/img/register/section2.jpg);
  background-size: 100% auto;
  background-position: center top;
  background-repeat: no-repeat;

  .play_buttom {
    position: absolute;
    width: 360px;
    height: 90px;
    top: 1010px;
    left: 195px;
    border: 1.5px solid;
    border-image-source: linear-gradient(0deg, #efd5ac, #efd5ac),
      radial-gradient(
        127.2% 100% at 50% 0%,
        #fff7e1 0%,
        rgba(255, 247, 225, 0.476611) 52.45%,
        rgba(255, 247, 225, 0) 100%
      );
    background: linear-gradient(
        360deg,
        #9b8155 15%,
        #cbaf7e 55.5%,
        #f3e8a8 100%
      ),
      linear-gradient(
        157.88deg,
        rgba(255, 255, 255, 0.8) -3.55%,
        rgba(255, 255, 255, 0) 49.43%
      );
    border-radius: 10px;
    cursor: pointer;

    p {
      font-size: 28px;
      line-height: 90px;
      text-align: center;
      color: #ffffff;
    }
  }
}

.lading.hasbottom {
  padding-bottom: 120px;
}

.float_bottom {
  z-index: 100;
  width: 100%;
  max-width: 750px;
  bottom: 0px;
  height: 128px;
  position: fixed;
  //background-image: url(/mobile/static/img/register/footer.jpg);
  background-size: 100% auto;
  background-position: center top;

  .download_btn {
    position: absolute;
    left: 520px;
    top: 38px;
    width: 151px;
    height: 70px;
    background-image: url("/static/img/register/btn_download.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center top;
    cursor: pointer;
  }

  .close {
    position: absolute;
    right: 0px;
    top: 0px;
    width: 40px;
    height: 40px;
    background-image: url("/static/img/register/close_btn.png");
    background-size: 20px 20px;
    background-position: center center;
    background-repeat: no-repeat;
    cursor: pointer;
  }
}
</style>
